import { Skeleton, styled } from '../../base';

export const StyledDashboardPageWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(4),
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.spacing(1),
}));
